import { firebaseConfig } from './firebaseConfig';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui-ja/dist/firebaseui.css';
import { AbstractTranslation } from '../lang/AbstractTranslation';

export const getFirebaseAuthUi = () => {
  const app = firebase.initializeApp(firebaseConfig);
  const auth = app.auth();
  auth.languageCode = AbstractTranslation.language === 'kana' ? 'ja' : AbstractTranslation.language;
  const firebaseAuthUi = new firebaseui.auth.AuthUI(auth, 'blockvrock');
  return firebaseAuthUi;
};
